import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

const KEY = 'vouchers.config.unsaved';

interface UnsavedChangesPromptProps {
  open: boolean;
  onLeave: () => void;
  onStay: () => void;
}

/**
 * Salir con cambios sin guardar. "Seguir editando" es la acción por defecto:
 * la destructiva es la otra, y quien llegó acá venía navegando sin querer
 * perder nada.
 */
export const UnsavedChangesPrompt: FC<UnsavedChangesPromptProps> = ({
  open,
  onLeave,
  onStay,
}) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onStay} aria-labelledby="vouchers-unsaved-title">
      <DialogTitle id="vouchers-unsaved-title">{t(`${KEY}.title`)}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t(`${KEY}.body`)}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={onLeave}>
          {t(`${KEY}.leave`)}
        </Button>
        <Button variant="contained" onClick={onStay} autoFocus>
          {t(`${KEY}.stay`)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
